import {combineReducers} from 'redux'
import {
    LINKS_LOADED,
    PATRIMONY_LOADED,
    PATRIMONY_STREAM_LOADED,
    PATRIMONY_STREAM_QUERIED,
    CRITERIA_UPDATED,
    MINOR_CRITERIA_UPDATED,
    MINOR_CRITERIA_RESETTED,
    LOT_LOADED,
    LOT_STREAM_LOADED,
    BUILDING_LOADED,
    CONTACT_LOADED,
    CONTACT_LINKS_LOADED,
    CONTACT_STREAM_LOADED,
    CONTACT_STREAM_QUERIED,
    CONTACT_CRITERIA_UPDATED,
    MINOR_CONTACT_CRITERIA_UPDATED,
    MINOR_CONTACT_CRITERIA_RESET,
    MINOR_CONTACT_STREAM_LOADED,
    MINOR_CONTACT_STREAM_QUERIED,
    UPDATE_USER_CMD_UPDATED,
    REFERENCE_USER_CMD_SENT,
    LINK_USER_CMD_SENT, getLogin, getPhone,
} from './actions'
import {
    REFERENCE_PATRIMONY_CMD_UPDATED,
    REFERENCE_LOT_CMD_UPDATED,
    REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED,
    UPDATE_PATRIMONY_CMD_UPDATED,
    UPDATE_LOT_CMD_UPDATED,
    UPDATE_LOT_CMD_RESET,
    ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED,
    ADD_ADDRESS_TO_LOT_CMD_UPDATED,
    LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED,
    UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED,
    ADD_CONTACT_CMD_UPDATED,
} from './actions'
import {
    REFERENCE_PATRIMONY_CMD_SENT,
    REFERENCE_LOT_CMD_SENT,
    REFERENCE_PATRIMONY_CONTACT_CMD_SENT,
    UPDATE_PATRIMONY_CMD_SENT,
    UPDATE_LOT_CMD_SENT,
    ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT,
    ADD_ADDRESS_TO_LOT_CMD_SENT,
    LINK_PATRIMONY_CONTACT_WITH_CMD_SENT,
    UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT,
    ADD_CONTACT_CMD_SENT,
} from './actions'

function patrimony(state = null, action) {
    switch (action.type) {
        case PATRIMONY_LOADED:
            return action.patrimony
        default:
            return state
    }
}

function patrimonyBuildings(state = null, action) {
    switch (action.type) {
        case PATRIMONY_LOADED:
            return action.patrimonyBuildings
        default:
            return state
    }
}


function patrimonyLots(state = null, action) {
    switch (action.type) {
        case PATRIMONY_LOADED:
            return action.patrimonyLots
        default:
            return state
    }
}

function patrimonyContacts(state = null, action) {
    switch (action.type) {
        case PATRIMONY_LOADED:
            return action.patrimonyContacts
        default:
            return state
    }
}

function stream(state = [], action) {
    switch (action.type) {
        case PATRIMONY_STREAM_LOADED:
        case PATRIMONY_STREAM_QUERIED:
            return action.stream
        default:
            return state
    }
}

function aggregations(state = null, action) {
    switch (action.type) {
        case PATRIMONY_STREAM_LOADED:
        case PATRIMONY_STREAM_QUERIED:
            return action.aggregations
        default:
            return state
    }
}

function range(state = null, action) {
    switch (action.type) {
        case PATRIMONY_STREAM_LOADED:
        case PATRIMONY_STREAM_QUERIED:
            return action.range
        default:
            return state
    }
}

function query(state = null, action) {
    switch (action.type) {
        case PATRIMONY_STREAM_LOADED:
        case PATRIMONY_STREAM_QUERIED:
            return action.query
        default:
            return state
    }
}

function _links(state = [], action) {
    switch (action.type) {
        case PATRIMONY_STREAM_LOADED:
        case PATRIMONY_STREAM_QUERIED:
        case LINKS_LOADED:
            return action._links
        default:
            return state
    }
}

function criteria(state = null, action) {
    switch (action.type) {
        case CRITERIA_UPDATED:
            return {...state, ...action.criteria}
        default:
            return state
    }
}

function minorCriteria(state = null, action) {
    switch (action.type) {
        case MINOR_CRITERIA_UPDATED:
            return {...state, ...action.minorCriteria}
        case MINOR_CRITERIA_RESETTED:
            return null
        default:
            return state
    }
}

function referencePatrimonyCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_PATRIMONY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REFERENCE_PATRIMONY_CMD_SENT:
            return null
        default:
            return state
    }
}

function referenceLotCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_LOT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REFERENCE_LOT_CMD_SENT:
            return null
        default:
            return state
    }
}

function referencePatrimonyContactCmd(state = null, action) {
    switch (action.type) {
        case REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REFERENCE_PATRIMONY_CONTACT_CMD_SENT:
            return null
        default:
            return state
    }
}

function updatePatrimonyCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_PATRIMONY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_PATRIMONY_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateLotCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_LOT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_LOT_CMD_SENT:
        case UPDATE_LOT_CMD_RESET:
            return null
        default:
            return state
    }
}

function addComplementaryAddressToPatrimonyCmd(state = null, action) {
    switch (action.type) {
        case ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT:
            return null
        default:
            return state
    }
}

function addAddressToLotCmd(state = null, action) {
    switch (action.type) {
        case ADD_ADDRESS_TO_LOT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ADD_ADDRESS_TO_LOT_CMD_SENT:
            return null
        default:
            return state
    }
}

function linkPatrimonyContactWithCmd(state = null, action) {
    switch (action.type) {
        case LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED:
            return {...state, ...action.cmd}
        case LINK_PATRIMONY_CONTACT_WITH_CMD_SENT:
            return null
        default:
            return state
    }
}

function updatePatrimonyContactIdentityCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED:
            const {cmd} = action
            const {namez} = cmd
            const {nameType, value, lastName} = namez
            const definedLastName = nameType === 'PoorName' ? value : lastName
            return {...state, ...action.cmd, namez: {...namez, lastName: definedLastName}}
        case UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT:
            return null
        default:
            return state
    }
}

function addContactCmd(state = null, action) {
    switch (action.type) {
        case ADD_CONTACT_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ADD_CONTACT_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateUserCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_USER_CMD_UPDATED:
            return action.cmd ? {...action.cmd} : null
        case REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED:
            const {shouldCreateUser, contacts, namez} = action.cmd
            const {firstName: cmdFirstName, lastName: cmdLastName, login: cmdLogin, shouldCreateUser: cmdShouldCreateUser} = state ? state : {firstName: null, lastName: null, login: null, shouldCreateUser: false}
            const {firstName, lastName} = namez ? namez : {firstName: cmdFirstName, lastName: cmdLastName}
            const mails = contacts ? contacts.find(c => c.contactInfoType === 'Mail') : {mail: cmdLogin}
            const {mail} = mails ? mails : {mail : null}
            const cmd = {
                commandType: 'ReferencePatrimonyUser',
                login: mail,
                lastName,
                firstName,
                shouldCreateUser: (typeof shouldCreateUser) === 'boolean' ? shouldCreateUser : cmdShouldCreateUser,
            }
            return cmd
        case REFERENCE_PATRIMONY_CONTACT_CMD_SENT:
            const {contactUid} = action
            return {
                ...state,
                contactUid
            }
        case REFERENCE_USER_CMD_SENT:
            const {userUid, status, errorType} = action
            return {...state, userUid, status, errorType}
        default:
            return state
    }
}

const lot = (function () {

    function lot(state = null, action) {
        switch (action.type) {
            case LOT_LOADED:
                return action.lot
            default:
                return state
        }
    }

    function lotContacts(state = null, action) {
        switch (action.type) {
            case LOT_LOADED:
                return action.lotContacts
            default:
                return state
        }
    }

    function stream(state = [], action) {
        switch (action.type) {
            case LOT_STREAM_LOADED:
                return action.lot.stream
            default:
                return state
        }
    }

    return combineReducers({lot, lotContacts, stream})
})()

const building = (function () {

    function building(state = null, action) {
        switch (action.type) {
            case BUILDING_LOADED:
                return action.building
            default:
                return state
        }
    }

    function buildingLots(state = null, action) {
        switch (action.type) {
            case BUILDING_LOADED:
                return action.buildingLots
            default:
                return state
        }
    }

    function stream(state = [], action) {
        switch (action.type) {
            case LOT_STREAM_LOADED:
                return action.building.stream
            default:
                return state
        }
    }

    return combineReducers({building, buildingLots, stream})
})()

const contact = (function () {

    function contact(state = null, action) {
        switch (action.type) {
            case CONTACT_LOADED:
                return action.contact
            default:
                return state
        }
    }

    function nameToSort({name}) {
        return [name.company, name.gender, name.firstName, name.lastName, name.value].filter(Boolean).join(' ')
    }

    function compareContacts(a, b) {
        const nameToSortA = nameToSort(a)
        const nameToSortB = nameToSort(b)
        return nameToSortA < nameToSortB ? -1 : 1
    }

    function stream(state = [], action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action.stream
            case REFERENCE_PATRIMONY_CONTACT_CMD_SENT:
                const {name, contactUid} = action
                return state.concat({
                    uid: contactUid,
                    name,
                    patrimonyUserState: {stateType: 'NoAccount'},
                    contacts: [],
                    _links: []
                }).sort(compareContacts)

            case LINK_USER_CMD_SENT:
                const associatedContact = state.find(c => c.uid === action.contactUid)
                const othersContact = state.filter(c => c.uid !== action.contactUid)
                const {login, userUid} = action

                return othersContact.concat({...associatedContact, patrimonyUserState: {stateType: 'NotActiveAccount', login, userUid}}).sort(compareContacts)
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action.range
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    function _links(state = [], action) {
        switch (action.type) {
            case CONTACT_STREAM_LOADED:
            case CONTACT_STREAM_QUERIED:
            case CONTACT_LINKS_LOADED:
                return action._links
            default:
                return state
        }
    }

    function minorStream(state = [], action) {
        switch (action.type) {
            case MINOR_CONTACT_STREAM_LOADED:
            case MINOR_CONTACT_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function minorRange(state = null, action) {
        switch (action.type) {
            case MINOR_CONTACT_STREAM_LOADED:
            case MINOR_CONTACT_STREAM_QUERIED:
                return action.range
            default:
                return state
        }
    }

    function minorQuery(state = null, action) {
        switch (action.type) {
            case MINOR_CONTACT_STREAM_LOADED:
            case MINOR_CONTACT_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    function criteria(state = null, action) {
        switch (action.type) {
            case CONTACT_CRITERIA_UPDATED:
                return {...state, ...action.criteria}
            default:
                return state
        }
    }

    function minorCriteria(state = null, action) {
        switch (action.type) {
            case MINOR_CONTACT_CRITERIA_UPDATED:
                return {...state, ...action.minorCriteria}
            case MINOR_CONTACT_CRITERIA_RESET:
                return action.minorCriteria
            default:
                return state
        }
    }

    return combineReducers({
        contact,
        stream,
        range,
        query,
        _links,
        criteria,
        minorCriteria,
        minorStream,
        minorRange,
        minorQuery,
    })
})()

export default combineReducers({
    lot,
    building,
    contact,
    patrimony,
    patrimonyBuildings,
    patrimonyLots,
    patrimonyContacts,
    stream,
    aggregations,
    range,
    query,
    _links,
    criteria,
    minorCriteria,
    referencePatrimonyCmd,
    referenceLotCmd,
    referencePatrimonyContactCmd,
    updatePatrimonyCmd,
    updateLotCmd,
    addComplementaryAddressToPatrimonyCmd,
    addAddressToLotCmd,
    linkPatrimonyContactWithCmd,
    updatePatrimonyContactIdentityCmd,
    addContactCmd,
    updateUserCmd,
})



// WEBPACK FOOTER //
// ./lib/patrimony/reducers.js